import { defineStyleConfig } from '@chakra-ui/react'

export const Text = defineStyleConfig({
  // The styles all button have in common
  baseStyle: {
    color: '#99ACD2',
    fontSize: '14px',
  },
})
